import React from 'react';
import { SettingSlider } from '../../Sliders';
import { IMAGE_SETTINGS } from '../constants';

import './settingsImage.scss'
import { useImageSettings } from '../../../LeftWorkArea/LeftWorkEditImage/useImageSettings';

export const Settings = () => {
    const { changeRotation, formState, handleScaleChange } = useImageSettings();

    return <div className='settings-image'>
        <SettingSlider onChange={(value) => {
            changeRotation({
                target: {
                    name: 'rotation',
                    value: `${value}`
                }
            })
        }} {...IMAGE_SETTINGS.rotate} value={formState.rotation} />

        <SettingSlider  onChange={(value) => {
            handleScaleChange({
                target: {
                    name: 'scale',
                    value: `${value}`
                }
            })
        }} {...IMAGE_SETTINGS.scale} value={formState.scale} />
    </div>
}